import { render, staticRenderFns } from "./BetSlipConfirmationRow.vue?vue&type=template&id=06722f77&"
import script from "./BetSlipConfirmationRow.vue?vue&type=script&lang=js&"
export * from "./BetSlipConfirmationRow.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipConfirmationRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports